import Vision from "../../images/about-us/vision.png";
import Mission from "../../images/about-us/mission.png";

function AboutVision({ ref, visible }) {
  return (
    <div className="about-us-vision" ref={ref}>
      <h1 className="large-vision">VISION</h1>
      <p className="large-mission">& MISSION</p>
      <div className={`vision ${visible ? "visible" : ""}`}>
        <div>
          <img src={Vision} alt="vision" />
          <h2>Vision</h2>
          <p>
            Our vision is to be a first-class Hub for enterprise solutions
            relied on by organizations in and around the world to drive their
            business processes.
          </p>
        </div>
      </div>
      <div className={`mission ${visible ? "visible" : ""}`}>
        <div>
          <img src={Mission} alt="mission" />
          <h2>Mission</h2>
          <p>
            Our mission is to provide our clients with world class enterprise
            technologies and business solutions that will help them increase
            efficiency, productivity and have competitive advantage.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutVision;
